import React, { useState, useEffect } from 'react';
import { useAssistant } from 'hooks/useAssistant';
import assistantGif from 'assets/img/layout/Assistente_AI.gif';
import { useNotifications } from 'context/NotificationContext';

const SidebarCard = () => {
  const { suggestions } = useAssistant();
  const { notifications } = useNotifications(); 
  const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const assistantSwitch = notifications.find(n => n.id === 'switch5');
  const isAssistantEnabled = assistantSwitch?.checked === true;

  const handleNextSuggestion = () => {
    setCurrentSuggestionIndex(prevIndex => prevIndex + 1);
  };

  useEffect(() => {
    const hasSuggestions = suggestions.length > 0;
    const allViewed = currentSuggestionIndex >= suggestions.length;

    setIsVisible(isAssistantEnabled && hasSuggestions && !allViewed);

    const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
    const timer = setTimeout(() => {
      if (hasSuggestions) {
        setCurrentSuggestionIndex(0);
      }
    }, FIVE_MINUTES_IN_MS);

    return () => clearTimeout(timer);
  }, [suggestions, currentSuggestionIndex, isAssistantEnabled]);

  return (
    <div className="relative flex flex-col items-start rounded-[20px] w-full p-4">
      {isVisible && (
        <div className="relative left-4 mb-2 w-[250px] bg-gray-100 rounded-xl p-4 text-sm text-navy-700 shadow-lg z-10">
          <h2 className="mb-2 font-bold">LISA falou:</h2>
          <p className="mb-2">
            {suggestions[currentSuggestionIndex]}
          </p>
          <button 
            onClick={handleNextSuggestion}
            className="text-xs font-bold text-brand-500 hover:text-brand-600"
          >
            Entendi
          </button>
          <div className="absolute bottom-[-9px] left-6 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-gray-100"></div>
        </div>
      )}

      <div className="h-24 w-24 mt-2">
        <img src={assistantGif} alt="Assistente AI" className="h-full w-full object-cover rounded-full pointer-events-none" />
      </div>
    </div>
  );
};

export default SidebarCard;
